import { Button, Card, List, ListItem, Divider } from '@material-tailwind/react';
import { PlusIcon } from '@heroicons/react/24/outline';
import { convertirFormato } from '../../ingresos/vista/Ingresos-draft';

export const TablaMobile = ({ registrosAmostrar, cleanUpData, onCrearIngreso }) => {
  return (
    <>
      <div className='mt-2 ml-2 mb-4 flex justify-end'>
        <Button className="flex items-center gap-2 bg-[#2FB18F]" onClick={onCrearIngreso}>
          <PlusIcon className='h-4 w-4' />
          Añadir
        </Button>
      </div>
      <Card className='mt-2'>
        <List>
            {registrosAmostrar.map((item, index) => (
                <>
                    <ListItem key={index} className='mb-1 border-[2px] border-b-gray-300/50'>
                        <div className='f-col space-y-2'>
                            <p><span className='font-bold'>Fecha: </span>{item.fecha}</p>
                            <p><span className='font-bold'>Titular: </span>{item.titular}</p>
                            <p><span className='font-bold'>Comprobante: </span>{item.comprobante}</p>
                            <p><span className='font-bold'>Provincia: </span>{item.provincia}</p>
                            <p><span className='font-bold'>Monto: </span>{convertirFormato(item?.monto?.toString())}</p>
                        </div>
                    </ListItem>
                </>
            ))}
        </List>
      </Card>
    </>

  )
}